import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import $$tracker from '@src/tracker';

class OrderTipsModalStore extends BaseModalStore {
  @observable closeCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  /** 微信预约 */
  goWechatReservation = () => {
    $$tracker.clickGoReservation();
    this.onClickClose();
  };

  use() {
    // 不调用 super.use()，避免自动激活弹窗
    // 弹窗的显示由外部手动控制 isOpen 和 isActive
  }
}

export default OrderTipsModalStore;
